<template>
  <div class="serve">
    <headerIndex type="1" ref="header" :isFromLocalServe="true"/>
    <div class="box-banner">
      <div class="content">
        <div class="u-flex u-row-between">
          <p class="head-title">
            {{ cityList ? cityList.name : "" }}企业服务网
          </p>
          <el-popover placement="bottom-end" popper-class="channel">
            <div style="padding: 10px 0px;line-height: 50px;">
              <el-button round v-for="channel of mine_channel" @click="swNode(channel)">{{ channel.name }}</el-button>
            </div>
            <div class="switchNodes u-flex" slot="reference">
              <img src="@/assets/img/home/sw.png" style="width: 16px"/>
              <span style="padding-left: 5px">切换节点</span>
            </div>
          </el-popover>
        </div>
        <div class="tabs u-flex">
          <!--<div class="tab-item" :class="{ isActive: tabIndex == 0 }" @click="openTab(0)">推荐</div>
          <span>|</span>-->
          <div class="tab-item" :class="{ isActive: tabIndex == 1 }" @click="openTab(1)">
            {{ cityList ? cityList.name : cityList ? cityList.name : "" }}动态
          </div>
          <span>|</span>
          <div class="tab-item" :class="{ isActive: tabIndex == 2 }" @click="openTab(2)">政策头条</div>
          <span>|</span>
          <div class="tab-item" :class="{ isActive: tabIndex == 3 }" @click="openTab(3)">招投标</div>
          <span>|</span>
          <div @click="openTab(4)" :class="{ isActive: tabIndex == 4 }" class="tab-item">
            {{ cityList.abridge == '皖' ? '徽' : cityList.abridge }}商
          </div>
          <span>|</span>
          <div class="tab-item" @click="Scloud">
            <span v-if="cityList.abridge == '皖'">徽商服务云</span>
            <span v-else>{{ cityList.abridge }}企服务云</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main-container" :style="'min-height:'+height_min+'px;'">
      <!--&lt;!&ndash; 推荐容器 &ndash;&gt;
      <localNewsList ref="news" v-if="tabIndex == 0" :cityNo="cityList ? cityList.key : ''"/>-->
      <!-- 本地热点 -->
      <localHotList ref="hot" v-if="tabIndex == 1" :cityNo="cityList ? cityList.key : ''" :cityList="cityList"/>
      <!-- 政策头条 -->
      <policy v-if="tabIndex == 2" :cityNo="cityList ? cityList.key : ''" :cityList="cityList"/>
      <!-- 招投标 -->
      <Bidding v-if="tabIndex == 3" :cityNo="cityList ? cityList.key : ''" :cityList="cityList"/>
      <!-- 园区板块 -->
      <garden v-if="tabIndex == 4" :cityNo="cityList ? cityList.key : ''" :cityList="cityList"/>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from '@/components/footer/home_footer';
import Hang from "@/components/Hang/Hang";
import localNewsList from "@/views/home/serviceNet/localNewsList";
import localHotList from "@/views/home/serviceNet/localHotList";
import policy from "@/views/home/serviceNet/policy";
import Bidding from "@/views/home/serviceNet/Bidding";
import garden from "@/views/home/serviceNet/garden";
import "@/assets/css/style.css";
import cityJson from "@/static/cityJson.json";
import {serviceNode} from '@/api/cloudServiceApi'

export default {
  components: {headerIndex, localNewsList, localHotList, policy, Bidding, Hang, garden, home_footer},
  name: 'localServe',
  data() {
    return {
      cityJson: cityJson,
      nodeList: [], //节点列表
      tabIndex: 1,
      nodesObj: {},
      mine_channel: [],
      fatherObj: null,
      cityList: {},
      height_min: document.documentElement.clientHeight - 447,
    };
  },
  methods: {
    //跳转服务云
    Scloud() {
      this.$router.push({
        path: '/ServiceCentre/serviceCloud',
        query: {pName: this.cityList.abridge + '企服务云'}
      })
    },
    //切换Tab
    openTab(index) {
      this.tabIndex = index;
    },
    //获取节点数据
    getRegionList() {
      serviceNode({cityCode: this.cityList.id, request: 'form', uid: this.cid != 0 && this.cid != undefined ? this.cid : 0}).then(res => {
        if (res.code == 200)
          this.mine_channel = res.content.list;
      })
    },
    changeCity(index, name) {
      this.cityList = {name: name, key: index}
      this.mine_channel[1] = {name: name, key: index}
      this.activeIndex = index;
      this.visible_popover = false
    },
    //点击切换节点
    swNode(row) {
      sessionStorage.setItem('childNode', JSON.stringify(row));
      this.$router.push({
        path: '/cloudPlatform/platform',
        query: {
          city: row.id,
          cityName: row.name,
          cityCode: row.cityCode,
          parentCityCode: row.parentCityCode,
          pName: row.name + '企业数字化服务云平台',
          parName: this.cityList.name+'企业服务网'
        }
      })
    }
  },
  mounted() {
    this.getRegionList();
  },
  beforeMount() {
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style>
.channel {
  max-width: 62%;
}

.channel .el-button + .el-button, .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px;
}

.channel .el-button {
  margin-right: 10px !important;
  min-width: 90px;
}
</style>
<style lang="scss" scoped>
.serve {
  background: #ffffff;

  .box-banner {
    height: 200px;
    width:100%;
    background: url("~@/assets/img/home/localBGI.png") no-repeat;
    background-size: 100% 100%;
    padding-bottom: 10px;
    .content {
      height: 100%;
      padding: 0px 18%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      margin: auto;
      position: relative;

      .main-nodes {
        width: 100%;
        background-color: #fff;
        z-index: 12;
        padding: 10px 30px;
        box-shadow: 0px 4px 8px 0px rgba(176, 176, 176, 0.58);
        position: absolute;
        top: 100px;

        .box {
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          .node-item {
            font-size: 14px;
            color: #333;
            background-color: #f1f1f1;
            line-height: 40px;
            width: 88px;
            text-align: center;
            border-radius: 20px;
            margin: 10px;
            padding: 0 10px;
            cursor: pointer;
            box-sizing: border-box;
          }
        }
      }

      .head-title {
        font-size: 44px;
        font-family: "SourceHanSansCN";
        color: #FFFFFF;
      }

      .switchNodes {
        font-size: 14px;
        background-color: rgba(255, 255, 255, 0.6);
        padding: 6px 10px;
        border-radius: 15px;
        cursor: pointer;
      }

      .tabs {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        margin-left: -15px;

        .tab-item {
          padding: 0 15px;
          cursor: pointer;
          position: relative;

          &.isActive::before {
            position: absolute;
            content: "";
            display: block;
            height: 3px;
            width: 40%;
            bottom: -10px;
            left: 30%;
            background-color: #fff;
          }
        }
      }
    }
  }

  .main-container {
    padding: 0px 18%;
    margin: auto;
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: transparent;
    z-index: 4;
  }
}
</style>